import { mapActions } from 'vuex';
import loaderMixin from '@/mixins/loader';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import { formMixin } from '@/components/forms/mixin';
import storyPreviewHomepageSurface from './story-preview-homepage-surface.vue';
import storyPreviewDetailSurface from './story-preview-detail-surface.vue';

const TOTAL_COLUMNS = 12;
const COLUMN_OPTIONS = [
  { label: '0%', value: 0 },
  { label: '8.3%', value: 1 },
  { label: '16.6%', value: 2 },
  { label: '25%', value: 3 },
  { label: '33.3%', value: 4 },
  { label: '41.6%', value: 5 },
  { label: '50%', value: 6 },
  { label: '58.3%', value: 7 },
  { label: '66.6%', value: 8 },
  { label: '75%', value: 9 },
  { label: '83%', value: 10 },
  { label: '91.6%', value: 11 },
];
const TYPE_OPTIONS = [
  { label: 'Desktop', value: 'desktop' },
  { label: 'Mobile', value: 'mobile' },
  { label: 'Detail', value: 'detail' },
];
export default {
  mixins: [
    formMixin,
    loaderMixin,
  ],
  props: {
    previewId: {},
  },
  data() {
    return {
      COLUMN_OPTIONS,
      TYPE_OPTIONS,
      typeChoice: TYPE_OPTIONS[0],
      columnChoice: {
        left: COLUMN_OPTIONS[0],
        middle: COLUMN_OPTIONS[7],
        right: COLUMN_OPTIONS[0],
      },
      fullPreviewData: null,
      previewDataVersion: 0,
    };
  },
  components: {
    alertBox,
    storyPreviewHomepageSurface,
    storyPreviewDetailSurface,
  },
  computed: {
    classModifiers() {
      return {
        'page-story-preview': true,
        [`page-story-preview--${this.typeChoice.value}`]: true,
      };
    },
    isColumnCountExceeding() {
      return (this.columnChoice.left.value + this.columnChoice.right.value) >= TOTAL_COLUMNS;
    },
    middleOption() {
      const sumColumns = this.columnChoice.left.value + this.columnChoice.right.value;
      return TOTAL_COLUMNS - sumColumns;
    },
    leftColumnClasses() {
      const option = this.columnChoice.left.value;
      return {
        column: true,
        [`small-${option}`]: !!option,
      };
    },
    middleColumnClasses() {
      return {
        column: true,
        [`small-${this.middleOption}`]: !!this.middleOption,
      };
    },
    rightColumnClasses() {
      const option = this.columnChoice.right.value;
      return {
        column: true,
        [`small-${option}`]: !!option,
      };
    },
    isDetailMode() {
      return this.typeChoice.value === 'detail';
    },
    selectedHomepageSection() {
      if (!this.fullPreviewData || this.isDetailMode) {
        return null;
      }
      const homePreviewData = this.fullPreviewData.homePagePreviewViewModel || {};
      if (this.typeChoice.value === 'mobile') {
        return homePreviewData.mobileContent || null;
      }
      return homePreviewData.desktopContent || null;
    },
    selectedDetailData() {
      if (!this.fullPreviewData || !this.isDetailMode) {
        return null;
      }
      return this.fullPreviewData.detailPageViewModel || null;
    },
    homepageSurfaceKey() {
      return `${this.typeChoice.value}-${this.previewDataVersion}`;
    },
    detailSurfaceKey() {
      return `detail-${this.previewDataVersion}`;
    },
  },
  methods: {
    ...mapActions('browse', ['getStoryFullPreview']),
    setDefaultColumnsByMode(mode) {
      switch (mode) {
        case 'mobile':
          this.columnChoice.left = COLUMN_OPTIONS[4];
          this.columnChoice.right = COLUMN_OPTIONS[4];
          return;
        case 'desktop':
          this.columnChoice.left = COLUMN_OPTIONS[0];
          this.columnChoice.right = COLUMN_OPTIONS[0];
          return;
        case 'detail':
          this.columnChoice.left = COLUMN_OPTIONS[0];
          this.columnChoice.right = COLUMN_OPTIONS[0];
          return;
        default:
          break;
      }
    },
    typeChoiceHandler(option) {
      this.setDefaultColumnsByMode(option.value);
    },
    loadPreviewData() {
      this.loaderAdd(document.body);
      return this.getStoryFullPreview(this.previewId)
        .then((responseData) => {
          this.fullPreviewData = responseData;
          this.previewDataVersion += 1;
          return responseData;
        })
        .catch(() => {
          this.fullPreviewData = null;
        })
        .finally(() => {
          this.loaderRemove(document.body);
        });
    },
  },
  watch: {
    typeChoice: {
      handler: 'typeChoiceHandler',
      immediate: true,
    },
    previewId: {
      handler: 'loadPreviewData',
      immediate: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-story-preview/page-story-preview.js